import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BreadcrumbService } from './breadcrumb.service';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
})
export class BreadcrumbComponent {
    @Input() path: Array<any> = [];
    @Input() showBreadcrumb: Array<any> = [];
    @Output() topicBreadcrumbClicked = new EventEmitter<number>();
    @Output() allTopicClicked = new EventEmitter<void>();

    breadcrumbs: Array<any> = [];

    constructor(private breadcrumbService: BreadcrumbService) {}

    ngOnInit() {
        this.breadcrumbService.currentBreadcrumbs.subscribe((breadcrumbs) => {
            this.breadcrumbs = breadcrumbs;
        });
    }

    onBreadcrumbClick(index: number) {
        console.log('BreadcrumbComponent.onBreadcrumbClick');
        this.topicBreadcrumbClicked.emit(index);
    }

    onAllClick() {
        console.log('BreadcrumbComponent.onAllClick');
        this.breadcrumbs = [];
        this.breadcrumbService.updateBreadcrumbs(this.breadcrumbs);
        this.allTopicClicked.emit();
    }
}
